import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { FilterParameter, QueryParamsService, FailureReasonUsageLabel } from 'common';
import { FailureReasonQueryResult, FailureReasonData, FailureReasonFilters } from '../failure-reason.model';
import { FailureReasonListFilterDialogComponent } from '../failure-reason-list-filter-dialog/failure-reason-list-filter-dialog.component';
import { readWrite } from '../../../user/user-permission/user-permission.data';
import { UserPermissionService } from '../../../user/user-permission/user-permission.service';
import { routerTransition } from '../../../shared/animations/router.animations';
import { FailureReasonFilterService } from '../failure-reason-filter.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-failure-reason-list',
    templateUrl: './failure-reason-list.component.html',
    styleUrls: ['./failure-reason-list.component.scss'],
    animations: routerTransition,
    standalone: false
})
export class FailureReasonListComponent implements OnInit {
  deleteSub: Subscription;

  filters: FailureReasonFilters;
  activeFilters: FilterParameter[] = [];

  constructor(
    private route: ActivatedRoute,
    private userPermissionService: UserPermissionService,
    private dialog: MatDialog,
    private failureReasonFilterService: FailureReasonFilterService,
    private queryParamsService: QueryParamsService) { }

  data: FailureReasonListComponentData;
  readWriteFailureReason: boolean;

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this)).subscribe((it: FailureReasonListComponentData) => {
      this.data = it;
    });
    this.route.queryParams.pipe(untilDestroyed(this)).subscribe(it => {
      this.queryParams = this.queryParamsService.init(it);
      this.activeFilters = this.failureReasonFilterService.addFilterParameters(this.queryParams);
    });

    this.userPermissionService.granted([readWrite('admin-failure-reasons')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.readWriteFailureReason = res);

    this.filters = new FailureReasonFilters(this.queryParams);
    this.paginator.pageSize = this.queryParams.limit;
    this.paginator.pageIndex = this.queryParams.skip / this.queryParams.limit;
  }

  activeFilterRemoved(activefilters: FilterParameter[]): void {
    if(!activefilters.length) return;
    activefilters.forEach(item => {
      this.filters.remove(item.id);
      this.failureReasonFilterService.filter(this.filters);
    });
  }

  filterDialog() {
    FailureReasonListFilterDialogComponent.show(this.dialog, this.queryParams)
      .subscribe(result => {
        if (result) {
          this.filters = result;
          this.paginator.firstPage();
          this.failureReasonFilterService.filter(result);
        }
      });
  }

  sortData(sort: Sort) {
    this.failureReasonFilterService.filter(this.filters, this.paginator, this.sort);
  }

  setPage(event: PageEvent) {
    this.failureReasonFilterService.filter(this.filters, this.paginator, this.sort);
  }

  formatUsage(data: FailureReasonData): string {
    let value = '';
    data.usage.forEach(u => {
        if(value != '')
            value += ', ';

        value += FailureReasonUsageLabel.get(u);
    });

    return value;
}


  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;

  queryParams: any;

  @ViewChild(MatSort)
  sort: MatSort;

  tableColumns: string[] = [
    'name',
    'code',
    'externalCode',
    'usage',
    'createdBy',
    'createdOn',
    'updatedBy',
    'updatedOn',
    'status',
    'actions'
  ];

}

export interface FailureReasonListComponentData {
  failureReasonQueryResult: FailureReasonQueryResult;
  failureReason: FailureReasonData;
}
